/**
 * Authentication service
 * Handles JWT token storage and retrieval
 */

import { clearSimulate } from './simulate';

const TOKEN_KEY = 'cfc_auth_token';
const USER_KEY = 'cfc_user_data';

/**
 * Store authentication token and user data
 */
export const setAuth = (token, userData) => {
  localStorage.setItem(TOKEN_KEY, token);
  if (userData) {
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
  }
};

/**
 * Get stored authentication token
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Get stored user data (returns null if missing or invalid JSON)
 */
export const getUser = () => {
  try {
    const userData = localStorage.getItem(USER_KEY);
    return userData ? JSON.parse(userData) : null;
  } catch {
    return null;
  }
};

/**
 * Clear authentication (logout)
 */
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem('cfc_last_tenant_code');
  clearSimulate();
};

/**
 * Store last used tenant code
 */
export const setLastTenant = (tenantCode) => {
  if (tenantCode) {
    localStorage.setItem('cfc_last_tenant_code', tenantCode);
  }
};

/**
 * Get last used tenant code
 */
export const getLastTenant = () => {
  return localStorage.getItem('cfc_last_tenant_code');
};

/**
 * Check if user is authenticated (has token)
 */
export const isAuthenticated = () => {
  return !!getToken();
};
